import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import analytics from 'utils/analytics';
import Layout from './Layout';
export default class ErrorHandler extends React.Component {
    static get propTypes() {
        return {
            code: PropTypes.number,
            description: PropTypes.string,
        };
    }
    static get defaultProps() {
        return {
            code: 404,
        };
    }
    componentDidMount() {
        analytics.track('error_handler', 'error', {
            code: this.props.code,
            url: location && location.href,
        });
    }
    render() {
        const { description, code } = this.props;
        return (_jsx(Layout, { children: _jsxs(Layout.Container, { children: [_jsx("h1", { children: description ? description : `${code} Not found` }), _jsx("p", { children: _jsx("a", { href: "/", children: "Back home" }) })] }) }));
    }
}
